import { useEffect, useState } from "react";

const NAV_LINKS = [
  { id: "hot", label: "热瓜推荐" },
  { id: "timeline", label: "考古时间线" },
  { id: "archive", label: "分类档案" },
  { id: "feature", label: "编辑部特稿" },
  { id: "faq", label: "常见问题" },
  { id: "subscribe", label: "订阅联系" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className="sticky top-0 z-50 w-full">
      {/* 编辑部报头 */}
      <div className="w-full bg-foreground-900 text-background-100">
        <div className="mx-auto flex w-full max-w-6xl items-center justify-between gap-3 px-4 md:px-6 py-1.5">
          <p className="hidden text-[11px] tracking-wide text-background-200/80 sm:block">
            旧料翻旧账 · 陈年往事时间线整理
          </p>
          <p className="text-[11px] tracking-wide">第 {String(88).padStart(3, "0")} 期 · 每周更新</p>
        </div>
      </div>

      {/* 主导航 */}
      <nav
        className={`w-full border-b transition-colors duration-300 ${
          scrolled
            ? "border-background-300/60 bg-background-50/95 backdrop-blur"
            : "border-background-300/60 bg-background-100"
        }`}
      >
        <div className="mx-auto flex w-full max-w-6xl items-center justify-between px-4 md:px-6 py-3">
          <a href="#top" className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-500 font-heading text-lg font-bold text-background-50">
              吃
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-xl font-black text-foreground-950">吃瓜考古社</span>
              <span className="text-[10px] tracking-[0.2em] text-foreground-600">CHI GUA KAO GU</span>
            </span>
          </a>

          <div className="hidden items-center gap-7 lg:flex">
            {NAV_LINKS.map((l) => (
              <a
                key={l.id}
                href={`#${l.id}`}
                className="editorial-link text-sm font-medium text-foreground-700 hover:text-accent-600"
              >
                {l.label}
              </a>
            ))}
          </div>

          <div className="flex items-center gap-2">
            <a
              href="#subscribe"
              className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              加入档案社
            </a>
            <button
              aria-label="打开菜单"
              onClick={() => setOpen((v) => !v)}
              className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 hover:bg-background-200 lg:hidden"
            >
              <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`} />
            </button>
          </div>
        </div>

        {open && (
          <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 lg:hidden">
            <div className="flex flex-col">
              {NAV_LINKS.map((l) => (
                <a
                  key={l.id}
                  href={`#${l.id}`}
                  onClick={() => setOpen(false)}
                  className="py-2.5 text-sm font-medium text-foreground-800 hover:text-accent-600"
                >
                  {l.label}
                </a>
              ))}
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}